// extracted by mini-css-extract-plugin
module.exports = {"user-avatar":"style_user-avatar__3g_Iv","user-actions":"style_user-actions__2os3L"};